import Text from 'components/Text'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import { isApplePlatformUtil } from 'utils/device/utils/get-platform'
import getUserAgentAppSelect from 'modules/training/modules/app/selectors/get-user-agent'

// @see {@link
// https://css-tricks.com/actually-the-san-francisco-typeface-does-ship-as-a-variable-font/}
export default function TextTitleCondensed ({ fw, fs, ...props }) {
  fw = fw || 650
  const style = {
    fontVariationSettings: `"wght" ${fw}, "wdth" 40`,
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
  }

  const userAgent = useSelector(getUserAgentAppSelect)
  if (!isApplePlatformUtil(userAgent)) {
    fs = 'body'
  }

  return (
    <Text
      fs={fs || 'title'}
      fw={fw}
      {...props}
      style={getStyleComponentUtil(style, props.style)}
    />
  )
}
